var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var nl2br = require('../helpers/nl2br');

// Job Area
module.exports = React.createClass({

	// Render
  	render: function(){
  		
  		/*
  		if(this.props.use_html){
  		var text = this.props.description;
  			text = text.replace(/\\n/ig, '\n');
  			text = text.replace(/\"/ig, '');
  			text = text.trim();
  		} else {
	  		var text = nl2br(this.props.description);
  		}
  		
  		text = text.replace(/href=\\/ig, 'target="_blank" href=');
  		text = text.replace(/\\>/ig, '>');
  		*/
  		
  		
	  	var text = this.props.description;
  		
  		if(this.props.use_html === 'true' || this.props.use_html === true){
  			text = text.replace(/\\n/ig, '\n');
  			text = text.replace(/•\\t/ig, '<br /> • ');
  			text = text.replace(/o\\t/ig, '<br /> • ');
  			text = text.replace(/\"/ig, '');
  			text = text.replace(/&lt;/ig, '<');
  			text = text.replace(/&gt;/ig, '>');
  			text = text.replace(/&quot;/ig, '');
  			text = text.replace(/&euro;/ig, '€');
  			text = text.trim();
  		} else {
  			text = text.replace(/•\\t/ig, '<br /> • ');
  			text = text.replace(/o\\t/ig, '<br /> • ');
  			text = text.replace(/\\n/ig, '');
  			text = text.replace('</p>"', '</p>');
  			text = text.replace('"<p>', '<p>');
  			text = text.trim();
  		}
  		
  		text = text.replace(/href=\\/ig, 'target="_blank" href=');
  		text = text.replace(/\\>/ig, '>');
  		 		
   		return (
   			<div className="job-description">
   				<div className="text markdown-body" dangerouslySetInnerHTML={{__html: text }} />  				
	  		</div>
	  	);
	}
});
